<div class="shares-container">
  <table-notification-table
    [collarId]="collarId()"
    [isAtLeastDataManager]="isAtLeastDataManager()"
    [rules]="rules()"
    (deleteRuleNotification)="deleteRuleNotification.emit($event)"
    (addNotification)="onAddNotification()"
    class="user-table"
  >
  </table-notification-table>
</div>
